import { LeftRightDesginIcon } from '@Components/Common/CommonMethods';
import HippaIconSection from '@Components/Common/HippaIconSection';
import React from 'react'
import AboutUsStyled from './about.style';
import parse from 'html-react-parser'
import _ from 'lodash';

const FirstSection = ({ heading, text }) => (
    <div className='first_section'>
        <h2 className='blu_e'>{parse(heading)}</h2>
        <p>{parse(text)}</p>
    </div>
);

const SecondSection = ({ children, image, heading, subheading }) => {
    return (
        <div className='passage_container'>
            {image &&
                <div className='image_section'>
                    <div className='image_border'><img src={image} /></div>
                </div>
            }
            <div className='headings'>
                <h2 className='orange'>{heading}</h2>
                {subheading && <h3 className='team-founder'>{subheading}</h3>}
            </div>
            <div className='text_section'>
                {children}
            </div>
        </div>
    )
}

const AboutUs = () => {
    return (
        <AboutUsStyled>
            <LeftRightDesginIcon>
                <div className='about-us'>
                    <div className='top_section'>
                        <FirstSection heading="Our Passion and Purpose?" text="Simply put…You." />
                        <FirstSection heading="The vision driving us?" text="Nutrigenomic innovation advancing optimal health." />
                        <FirstSection heading={`How we contribute to the <br/> greater good`} text="Empowering personal wellness for generations to come." />
                        <FirstSection
                            heading="Aspirations that align us"
                            text={`Authenticity, Authority, Continuous Improvement, Education, Impact, Inclusivity, Integrity, Optimism, Passion, Persistence, Privacy, Trust`}
                        />
                    </div>
                    <div className='main_container'>
                        <SecondSection heading="Our Team">
                            <p>Passion, purpose and innovation are in the DNA of every member of our team.</p>
                            <p>We are a small but mighty force, shaking up the wellness lifestyle industry through cutting-edge
                                solutions merging nutrition and genomics.</p>
                            <p>We believe in the power of personalization and in the endless potential of precision nutrition.</p>
                            <p>In everything we do, our goal is empowering personal wellness for generations to come.</p>
                        </SecondSection>
                        <SecondSection heading="Kim Ressler" image="/images/ceo.png" subheading="Founder and Chief Executive Officer (CEO)">
                            <p>Kim Ressler is passionate about advancing human health through biotech innovation and is proud
                                to lead SNiP Nutrigenomics from its inception.</p>
                            <p>She became passionate about nutrigenomics after spending over ten years coping with health
                                challenges. Frustrated with both conventional and traditional medicine's failure to impact
                                long-term change, Kim discovered the staying power of nutritional genomics and subsequently
                                devoted her life to spreading awareness of and access to nutraceuticals over pharmaceutical
                                interventions.</p>
                            <p>Kim founded SNiP Nutrigenomics on the premise that effective wellness solutions shouldn't be
                                out of reach; that all people should have access to simple, affordable tools supporting their
                                immediate and long-term health goals. Working with medical providers, retailers, employers, and
                                consumers, Kim is proud to offer a powerful, all-in-one foundational nutritional supplement wholly
                                customized for an individual based on their DNA, along with life-changing, actionable genomic
                                and epigenetic insights.</p>
                            <p>A mother to four incredible and creative children, Kim lives with her husband, youngest daughter,
                                two cats, and one dog in sunny Laguna Beach, CA. Kim loves long walks on the beach, live music,
                                farm-to-table cuisine, and traveling to places where she can enjoy all three.</p>
                        </SecondSection>

                        <SecondSection heading="Andreanna Rainville" image="/images/advisor.png" subheading="RN, NC, Scientific Advisor">
                            <p>Andreanna Rainville (“Nurse Andi”), RN, NC, is a registered nurse and nutritional counselor, respected lecturer, instructor, and practitioner focusing on issues of genetics and methylation evaluation and support, nutraceutical medicine, diet therapy, immunotherapy, chronic illness and infection, detoxification, fertility, mold, pain management and pediatrics. She is also a member of the International Society of Nutrigenetics & Nutrigenomics (ISNN).</p>
                            <p>Raised on Kauai, Hawaii’s “garden island,” Andi has a lifelong curiosity for and connection to plantand nature-based health and wellness practices, serving individuals in all stages of human
                                development.</p>
                            <p>Andi began her career in the healing arts as a chiropractic assistant, massage
                                therapist/esthetician, and certified herbalist. She later developed a line of all-natural products
                                embraced by five-star spas in the United States and beyond.</p>
                            <p>Andi has worked with esteemed leaders in their fields, including Cynthia Keller, M.D. and Peter
                                Levine, Ph.D., and globally renowned physician, Dr. Dietrich Klinghardt (M.D./Ph.D.). Andi’s work
                                with Dr. Klinghardt spanned clinical (lead nurse) to educational (primary instructor for Klinghardt
                                Academies) for two decades.</p>
                            <p>Andi’s passion for and experience in physics, Functional German Medicine, pain management,
                                stem cell therapy, genetics, detoxification, and laser and light therapies, among many other
                                specialties, make Andi a highly sought-after provider.</p>
                            <p>Andi’s life’s passion is empowering people to envision multiple choices for wellness. In addition to
                                her work as Scientific Advisor for SNiP Nutrigenomics, Andi maintains a private clinical practice in
                                Kenmore, WA.</p>
                            <p>Andi is also a wife and mother to a 14-year-old, whom Rainville calls her "..source of never-ending
                                learning and love." She enjoys laughter, science innovations, farm-to-table style cooking and
                                beach or forest adventure with people or dogs.</p>
                        </SecondSection>

                        <SecondSection heading="Corey Colwell, MA, LMFT" image="/images/coo.png" subheading="Chief Operating Officer (COO)">
                            <p>A nationally recognized author, speaker, and innovation strategist, Corey ignites human potential to connect, evolve, and inspire.</p>
                            <p>Corey’s why-didn’t-I-think-of-that ideas have been featured in hundreds of media outlets, on television, radio, online, and in print, including Good Morning America, Real Simple, LA Times, NPR, CNN, and more.</p>
                            <p>As a licensed psychotherapist with a 20-year integrative and holistic clinical practice, Corey possesses unique expertise in mind-body wellness, and a knack for bridging people, concepts, and solutions. Her collaborators have included nationally known entities in health, sustainability, technology, beauty, fashion, retail, non-profit and education..</p>
                            <p>Corey’s passion for natural solutions runs deep, crediting her own health recovery—and her daughter’s ability to overcome epilepsy—to holistic and nutrition-based interventions.</p>
                            <p>Corey is a recent empty-nester who lives in Seattle, Washington, with her husband and rescue dog named Dodger. In her spare time, she enjoys water sports, sunsets, and discovering hot new health tech..</p>

                        </SecondSection>


                        <SecondSection heading="Sarah Cuoco" image="/images/Sarah-new.jpg" subheading="Affiliate Liaison">
                            <p>
                                Sarah Cuoco is a pivotal member of the SNiP Nutrigenomics team as an Affiliate Liaison,
                                embodying a lifelong commitment to making a difference. Her journey began as a certified Sign Language Interpreter,
                                a role that honed her profound ability to connect with diverse individuals.
                                Her exploration into nutrigenomics over the last five years has been transformative,
                                equipping her to guide others on their health journey with knowledge and empathy.
                            </p>
                            <p>
                                Bringing a wealth of experience from event coordination to entrepreneurship,
                                Sarah's dedication to finding her true calling culminated in the field of nutrigenomics — a discipline she credits for revolutionizing
                                her life and wellness perspective.
                            </p>
                            <p>
                                Nestled on the Western Slope of Colorado, Sarah, alongside her husband Chris, thrives amidst the great outdoors,
                                whether they're hiking, snowshoeing, or cycling. Their adventurous spirit also extends to performing arts,
                                where Sarah's passion for singing and acting shines in local theater productions.
                                Her role as Miss Mona in <em>The Best Little Whorehouse in Texas</em> remains a cherished highlight.
                            </p>


                        </SecondSection>



                    </div>
                </div>
            </LeftRightDesginIcon>
        </AboutUsStyled>
    )
}

export default AboutUs;